type RuntimeErrorLike = {
  code?: unknown;
  message?: unknown;
};

const normalizeRuntimeErrorText = (value: unknown): string =>
  String(value || '')
    .trim()
    .toLowerCase();

export const getFirebaseRuntimeErrorCode = (error: unknown): string => {
  const candidate = error as RuntimeErrorLike | null | undefined;
  return normalizeRuntimeErrorText(candidate?.code);
};

export const getFirebaseRuntimeErrorMessage = (error: unknown): string => {
  const candidate = error as RuntimeErrorLike | null | undefined;
  return String(candidate?.message || '').trim();
};

export const getFriendlyFirebaseRuntimeError = (error: unknown, fallback: string): string => {
  const code = getFirebaseRuntimeErrorCode(error);
  const message = normalizeRuntimeErrorText(getFirebaseRuntimeErrorMessage(error));

  if (code.includes('storage/quota-exceeded') || code.includes('quota-exceeded')) {
    return 'Limit miejsca na pliki został wyczerpany. Spróbuj ponownie później lub skontaktuj się z obsługą.';
  }

  if (code.includes('resource-exhausted')) {
    return 'Limit usługi został chwilowo wyczerpany. Spróbuj ponownie później.';
  }

  if (code.includes('permission-denied')) {
    return 'Nie masz uprawnień do wykonania tej akcji.';
  }

  if (code.includes('unauthenticated')) {
    return 'Sesja wygasła. Zaloguj się ponownie.';
  }

  if (code.includes('failed-precondition')) {
    return 'Ta akcja nie jest teraz dostępna. Odśwież dane i spróbuj ponownie.';
  }

  if (code.includes('invalid-argument')) {
    return 'Sprawdź dane formularza i spróbuj ponownie.';
  }

  if (
    code.includes('internal') ||
    code.includes('unavailable') ||
    code.includes('deadline-exceeded')
  ) {
    return 'Wystąpił chwilowy problem po stronie serwera. Spróbuj ponownie za chwilę.';
  }

  if (
    message.includes('failed to fetch') ||
    message.includes('networkerror') ||
    message.includes('cors') ||
    message.includes('offline')
  ) {
    return 'Nie udało się połączyć z usługą. Sprawdź połączenie i spróbuj ponownie.';
  }

  return fallback;
};
